type StepperHeaderProps = {
    stepperTitle:string
}

export const StepperHeader = ({stepperTitle}:StepperHeaderProps)=>{
    
    return (
        <div className='d-flex justify-content-between '>
        <p className='link-primary-pink'>{stepperTitle}</p>
        <div className='d-flex'>
          <span className='text-error' style={{ fontSize: "16px" }}>*</span>
          <span className='text-error'>required</span>
        </div>
      </div>
    )
}